function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment, useCallback, useContext, useMemo, useState } from "react";
import Label from "../../../../../grid/layouts/background-image-cards-grid/card-button/label/label";
import { ConditionalWrapper } from "utils/react";
import { getCapitilizedString } from "utils/strings";
import { GenericConfigContext } from "/contexts/generic-config-context";
import { getBrandCtaHexColor } from "/services/brand-service";
import { TIERS } from "constants/pricing";
import classnames from "classnames";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
import TooltipComponent from "components/enhancements/tooltip/tooltip-component";
import { DARK_THEME } from "components/enhancements/tooltip/tooltip-constants";
import Button from "components/core/button/button-component";
import { shouldShowPurchaseNow } from "services/ab-tests/monetization-ab-tests-service";
import TierAiBlock from "./tier-ai-block/tier-ai-block-component";
import CreditsSpecialOffer from "./credits-special-offer/credits-special-offer";
import { CREDITS_PER_TIER, CREDITS_TIER_FEATURES, CREDITS_PER_SEAT_TIER_FEATURES } from "constants/pricing/credits-config";
import { getCurrencyName } from "services/pricing-service";
import Colors from "styles/colors";
import { BRAND_BLACK_TEXT_COLOR } from "styles/color-consts";
import { hasLearnMoreVideo, getVideoIdByLocaleAndTier } from "services/pricing-learn-more-service";
import YouTubePopUpButton from "segments/desktop/core-components/button/youtube-popup-button/youtube-popup-button";
import { SECONDARY_BUTTON_TYPE } from "segments/desktop/core-components/button/button-consts";
import { trackEvent } from "services/bigbrain-service";
import MondayMarkupLanguageComponent from "client/components/system/monday-markup-language/monday-markup-language-component";
import { HP_SOURCE, CONTACT_US_BUTTON_CLICKED, PRICING_PAGE_FEATURE_INFO_ICON_HOVER, PRICING_PAGE_FEATURE_INFO_ICON_EXIT, PRICING_PAGE_FREE_TIER_COMING_SOON_HOVER } from "constants/bigbrain-event-types";
import { HOMEPAGE_PRICING_TIER_SOURCE } from "constants/cookies";
import { CRM_PRODUCT_ID, MARKETING_CAMPAIGNS_PRODUCT_ID, PLATFORM_PRODUCT_IDS, WORK_MANAGEMENT_PRODUCT_ID } from "constants/products";
import { ProductIcon } from "../../../../icons/product-icon";
import PricingInfoIcon from "/static/svg/pricing-info-icon.svg";
import EnterpriseIcon from "/static/svg/pricing-enterprise-icon.svg";
import NewEnterpriseIcon from "/static/svg/new-pricing-enterprise-icon.svg";
import { ContactUsIcon } from "./contact-us-icon";
import { ProductPrice } from "./product-price/product-price";
import { withAbTests } from "/contexts/ab-tests-context";
import { getTierTranslationKey } from "/services/pricing/plans-service";
import { setCookie } from "/services/cookies-service";
import { shouldShowEnterpriseToUltimateRename } from "/services/ab-tests/acquisition-ab-test-service";
import { StyledProductPriceAndFeatures, StyledProductPriceAndFeaturesWrapper } from "./product-price-and-features-card.scss";
import { CARD_CLASS, DEFAULT_CONTACT_SALES_LINK, DEFAULT_CONTACT_SALES_LINK_ULTIMATE_RENAME } from "./consts";
import { addProductParamToContactSalesUrl } from "segments/desktop/core-components/contact-sales-button/contact-sales-url";
import { HUBSPOT_CONTACT_SALES_CTA, HUBSPOT_CONTACT_SALES_CTA_TRANSLATED } from "/client/services/hubspot-service/hubspot-constants";
import { getRawTranslationValue } from "/services/localization/localization-service";
import NewCardFeatures from "../new-card-features/new-card-features";
import PictureComponent from "components/core/picture/picture-component";
import { MAX_NO_TOUCH_BUCKET_SIZE } from "segments/desktop/pricing/constants";
import PricingFeature from "../../../addons/pricing-feature/index.js";
import MondayAiIcon from "components/core/monday-ai-icon/monday-ai-icon-component";
import { isAddonAvailableForTier } from "constants/addons";
import AiExpandableBundle from "./ai-expandable-bundle/ai-expandable-bundle-component";
import EnterpriseSupportSvg from "./svgs/enterprise-support-svg";
import UltimateBriefcaseSvg from "./svgs/ultimate-briefcase-svg";
import TailoredOnboardingSvg from "./svgs/tailored-onboarding-svg";
const AI_FEATURES = [
    "ai_credits",
    "sidekick_ai_assistant"
];
const BASIC_CREDITS_STORAGE_FEATURE = "credits5GbFileStorage";
const PER_USER_PER_MONTH_HEADING_KEY = "pricingPage.products.crm.features.sections.perUserPerMonth";
const AI_USAGE_HEADING_KEY = "pricingPage.products.crm.features.sections.aiUsage";
const FEATURE_LEADING_ICONS = {
    creditsEnterpriseSupport: /*#__PURE__*/ _jsx(EnterpriseSupportSvg, {}),
    creditsPerSeatEnterpriseSupport: /*#__PURE__*/ _jsx(EnterpriseSupportSvg, {}),
    creditsTailoredOnboarding: /*#__PURE__*/ _jsx(TailoredOnboardingSvg, {})
};
// CRM classic feature rows reuse the shared per-feature descriptions authored
// for the pre-classic `newFeatures` layout (`pricingPage.products.crm.features.
// <id>.description`). Several classic rows use a different id than the
// description key, so map them here. Ids with no entry fall through to a direct
// id match. Ids that have no copy in either namespace
// (activeContactsAndDeals, unlimitedContactsAndDeals, apiCallsPerDay,
// creditsTailoredOnboarding) simply render without a tooltip until copy exists.
const CRM_CLASSIC_DESCRIPTION_ALIASES = {
    customDashboard: "dashboard",
    customDashboards: "dashboards",
    unlimitedCustomDashboards: "dashboards",
    quotesAndInvoicesPerMonth: "quotesAndInvoices",
    unlimitedQuotesAndInvoices: "quotesAndInvoices",
    generateQuotesAndInvoices: "quotesAndInvoices",
    customAutomationsPerMonth: "automations",
    enterpriseScaleAutomations: "automations",
    centralizedCommsHub: "centralizedCommunicationHub",
    iosAndAndroidApps: "mobileApp",
    sendMassEmails: "massEmail",
    setEmailSequences: "sequences",
    creditsEnterpriseSupport: "enterpriseSupport",
    unlimitedColumnsPerBoard: "columnsPerBoard",
    advancedPermissions: "multiLevelPermissions",
    hipaaCompliance: "hippaCompliance",
    advancedLogRules: "advancedLoggingRules"
};
// `crm.features.workspace.description` currently holds the guests copy (a
// mis-paste), so skip the shared fallback for the workspace rows until correct
// copy is authored — otherwise they'd show a guests tooltip.
const CRM_CLASSIC_DESCRIPTION_DENYLIST = new Set([
    "workspace",
    "workspaces",
    "unlimitedWorkspaces"
]);
// Tooltip copy changed after these rows' description keys were already
// translated, and the translation pipeline only picks up keys it hasn't seen.
// Resolve the tooltip against a fresh id so the new copy gets translated; the
// label keys stay on the original ids and keep their existing translations.
const FEATURE_DESCRIPTION_ID_OVERRIDES = {
    creditsApiCalls1K: "creditsApiCalls1KExternal",
    creditsApiCalls10K: "creditsApiCalls10KExternal",
    creditsApiCalls25K: "creditsApiCalls25KExternal"
};
const TOP_TIER_SUPPORT_SECTION_START = "creditsEnterpriseSupport";
const CREDITS_PER_SEAT_TOP_TIER_SUPPORT_SECTION_START = "creditsPerSeatEnterpriseSupport";
const filterOutAiFeaturesIfCreditsEnabled = (features, enableCreditsPricing, productName)=>{
    if (!features) return [];
    if (enableCreditsPricing && productName === PLATFORM_PRODUCT_IDS[WORK_MANAGEMENT_PRODUCT_ID]) {
        return features.filter((feature)=>!AI_FEATURES.includes(feature));
    }
    return features;
};
const HIPAA_LOGO_SRC = "/static/img/footer/hipaa-logo.png";
const SOC_LOGO_SRC = "/static/img/footer/soc-logo.png";
const ProductPriceAndFeatures = ({ productName, productId, period, tier, previousTierName, color, colorMobile, ctaHoverBackgroundColor, ctaHoverBorderColor, ctaHoverTextColor, primaryColor, secondaryColor, seats, isMostPopular, abTests, onPurchaseNowClicked, hideFreeForever, isHomepagePricing, isApplyMaxDiffFeatures, showLearnMoreVideo, showFreeTierComingSoon, labeledTierFeatures, isNewPricing, unitOfMeasure, crossedPricingUI, useClassicCardChrome, creditsPerSeat, addon, selectedUnit, addonTotalPrice, creditsWrapperRef, minCreditsWrapperHeight, mobileCardWrapperRef, minMobileCardHeight })=>{
    var _translate;
    // Chrome-only view of `isNewPricing`: card title style, feature-list
    // renderer, security logos, description position, learn-more video,
    // horizontal separator. Price-display concerns (crossed reference price,
    // discount chip, "per seat per month" copy) still consume `isNewPricing`
    // directly via ProductPrice/PeriodSelect so opting into classic chrome does
    // not alter the price section.
    const isNewPricingChrome = isNewPricing && !useClassicCardChrome;
    const { name: tierName, features } = tier;
    const effectiveAddon = addon && isAddonAvailableForTier(addon, tier.name) ? addon : null;
    const { isNewBrand, translate, forcePricing, translateWithParam, localeId, isMobileOrTabletBrowser, simulateGetQuoteAndScrollToForm, simulateEnterpriseToUltimateRenameTest, enableCreditsPricing, contactSalesProductParam, currency: currencyFromContext, forceCurrency, cloudfrontViewerCountry } = useContext(GenericConfigContext);
    const currency = currencyFromContext || getCurrencyName({
        forceCurrency,
        countryCode: cloudfrontViewerCountry
    });
    const [selectedCredits, setSelectedCredits] = useState(CREDITS_PER_TIER[tierName]);
    const maxNoTouchBucketSize = MAX_NO_TOUCH_BUCKET_SIZE[unitOfMeasure];
    const shouldShowPrices = tierName !== TIERS.ENTERPRISE && seats < maxNoTouchBucketSize;
    const canPurchaseNow = shouldShowPurchaseNow({
        abTests,
        forcePricing
    });
    const isFreeOrEnterprise = [
        TIERS.FREE,
        TIERS.ENTERPRISE
    ].includes(tierName);
    const shouldShowGetQuote = simulateGetQuoteAndScrollToForm;
    const contactUsTranslateKey = shouldShowGetQuote ? "pricingPage.get_quote" : "footer.contactSales";
    const contactUsText = translate(contactUsTranslateKey);
    const oneAiProductLogos = useMemo(()=>[
            {
                src: "https://dapulse-res.cloudinary.com/image/upload/v1771244600/Generator_featured%20images/Growth/Classic/vibe-logo.svg",
                darkSrc: "https://dapulse-res.cloudinary.com/image/upload/v1771244601/Generator_featured%20images/Growth/Classic/vibe-logo-dark.svg",
                alt: "monday vibe",
                tooltip: translate("pricingPage.enterprise.aiBundle.tooltip.vibe")
            },
            {
                src: "https://dapulse-res.cloudinary.com/image/upload/v1771244599/Generator_featured%20images/Growth/Classic/sidekick-logo.svg",
                darkSrc: "https://dapulse-res.cloudinary.com/image/upload/v1771244600/Generator_featured%20images/Growth/Classic/sidekick-logo-dark.svg",
                alt: "monday sidekick",
                tooltip: translate("pricingPage.enterprise.aiBundle.tooltip.sidekick")
            },
            {
                src: "https://dapulse-res.cloudinary.com/image/upload/v1771244599/Generator_featured%20images/Growth/Classic/ai-credits-logo.svg",
                darkSrc: "https://dapulse-res.cloudinary.com/image/upload/v1771244599/Generator_featured%20images/Growth/Classic/ai-credits-logo-dark.svg",
                alt: "monday AI credits",
                tooltip: translate("pricingPage.enterprise.aiBundle.tooltip.ai-credits")
            }
        ], [
        translate
    ]);
    const onPurchaseNowClick = (e)=>{
        const { currentTarget } = e;
        const purchaseNowLinkParent = currentTarget.closest(`div.${CARD_CLASS}`);
        const signupButton = purchaseNowLinkParent.querySelector("button");
        onPurchaseNowClicked({
            tier,
            target: signupButton
        });
    };
    const tierIncludesText = useMemo(()=>{
        return !previousTierName ? translateWithParam("pricingPage.tierCards.planIncludes", translate(getTierTranslationKey(tier.name))) : translateWithParam("pricingPage.tierCards.includesPlanPlus", translate(getTierTranslationKey(previousTierName)));
    }, [
        previousTierName,
        translateWithParam,
        tier,
        translate
    ]);
    const getLearnMoreButtonText = ()=>{
        return translateWithParam("pricingPage.tierCards.learnMoreButton", tier.name);
    };
    const featuresOrMaxDiffFeatures = useMemo(()=>{
        if (enableCreditsPricing && productName === PLATFORM_PRODUCT_IDS[WORK_MANAGEMENT_PRODUCT_ID]) {
            const creditsTierFeatures = creditsPerSeat ? CREDITS_PER_SEAT_TIER_FEATURES[tierName] : CREDITS_TIER_FEATURES[tierName];
            if (creditsTierFeatures) {
                if (creditsPerSeat) return creditsTierFeatures;
                return tierName === TIERS.BASIC ? creditsTierFeatures.filter((feature)=>feature !== BASIC_CREDITS_STORAGE_FEATURE) : creditsTierFeatures;
            }
        }
        if (isHomepagePricing && productName === PLATFORM_PRODUCT_IDS[WORK_MANAGEMENT_PRODUCT_ID]) {
            const { maxDiffFeatures } = tier;
            return isApplyMaxDiffFeatures && maxDiffFeatures ? maxDiffFeatures : features;
        }
        return features;
    }, [
        features,
        isApplyMaxDiffFeatures,
        isHomepagePricing,
        productName,
        tier,
        enableCreditsPricing,
        creditsPerSeat,
        tierName
    ]);
    const renderLearnMoreVideoCTAOrPlaceholder = ()=>{
        const hasVideo = hasLearnMoreVideo(tier.name);
        const showVideoButton = hasVideo && showLearnMoreVideo;
        // CRM classic has no learn-more video on any tier, so skip the empty
        // placeholder instead of reserving its height. Other products keep the
        // placeholder to stay aligned when only some tiers expose a video.
        if (isCrmClassic && !showVideoButton) {
            return null;
        }
        return /*#__PURE__*/ _jsx("div", {
            className: "tier-learn-more-button",
            children: showVideoButton && /*#__PURE__*/ _jsx(YouTubePopUpButton, {
                isWithIcon: true,
                isWithIconInsteadOfArrow: true,
                withoutUnderline: true,
                minPadding: true,
                outline: true,
                isWithArrow: false,
                iconColor: color,
                buttonText: getLearnMoreButtonText(),
                videoId: getVideoIdByLocaleAndTier(localeId, tier.name),
                buttonDisplayType: SECONDARY_BUTTON_TYPE,
                extraEventData: {
                    buttonName: "hp_pp_tier_learn_more",
                    tier: tier.name,
                    locale: localeId
                }
            })
        });
    };
    const sendHoverEvent = (feature, eventName)=>{
        trackEvent(eventName, {
            info1: feature,
            info2: tier.name,
            kind: feature,
            productKind: productName
        });
    };
    const onMouseEnter = (feature)=>{
        sendHoverEvent(feature, PRICING_PAGE_FEATURE_INFO_ICON_HOVER);
    };
    const onMouseLeave = (feature)=>{
        sendHoverEvent(feature, PRICING_PAGE_FEATURE_INFO_ICON_EXIT);
    };
    const onMouseEnterComingSoon = (feature)=>{
        trackEvent(PRICING_PAGE_FREE_TIER_COMING_SOON_HOVER, {
            info2: tier.name,
            productKind: productName
        });
    };
    const showComingSoon = useMemo(()=>{
        return showFreeTierComingSoon && tierName === TIERS.FREE;
    }, [
        showFreeTierComingSoon,
        tierName
    ]);
    const navigateToContactSales = useCallback(()=>{
        const isUltimateRename = simulateEnterpriseToUltimateRenameTest || shouldShowEnterpriseToUltimateRename(productName);
        const baseUrl = isUltimateRename ? DEFAULT_CONTACT_SALES_LINK_ULTIMATE_RENAME : DEFAULT_CONTACT_SALES_LINK;
        window.location.href = addProductParamToContactSalesUrl(baseUrl, contactSalesProductParam);
    }, [
        simulateEnterpriseToUltimateRenameTest,
        productName,
        contactSalesProductParam
    ]);
    const onContactUsClick = useCallback(()=>{
        var _localStorage, _localStorage1;
        (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.setItem(HUBSPOT_CONTACT_SALES_CTA, getRawTranslationValue(contactUsTranslateKey));
        (_localStorage1 = localStorage) === null || _localStorage1 === void 0 ? void 0 : _localStorage1.setItem(HUBSPOT_CONTACT_SALES_CTA_TRANSLATED, contactUsText);
        trackEvent(CONTACT_US_BUTTON_CLICKED, {
            placement: "tier-value-card",
            source: HP_SOURCE,
            info1: tier.name,
            info2: seats,
            productKind: productName,
            data: {
                buttonText: contactUsText
            }
        });
        if (shouldShowGetQuote) {
            const formElement = document.getElementById("form");
            if (formElement) {
                formElement.scrollIntoView({
                    behavior: "smooth"
                });
                return;
            }
        }
        navigateToContactSales();
    }, [
        abTests,
        contactSalesProductParam,
        productName,
        seats,
        tier.name,
        navigateToContactSales
    ]);
    const handleBeforeSubmitCallback = ()=>{
        setCookie(HOMEPAGE_PRICING_TIER_SOURCE, `${productName}-${tierName}`);
    };
    const shouldShowDisclaimerForEnterprise = ()=>{
        if (productName !== CRM_PRODUCT_ID) {
            return false;
        }
        if (tierName !== TIERS.ENTERPRISE) {
            return false;
        }
        return simulateEnterpriseToUltimateRenameTest || shouldShowEnterpriseToUltimateRename(productName);
    };
    const translatedTierName = translate(getTierTranslationKey(tierName, {
        hasStudentPlan: false,
        productName,
        abTests,
        forceUltimateRename: simulateEnterpriseToUltimateRenameTest
    }));
    const productColor = typeof colorMobile === "string" ? colorMobile : color;
    const isCrmClassic = useClassicCardChrome && productName === CRM_PRODUCT_ID;
    // CRM classic value rows color the leading token (quantity: "1,000",
    // "Unlimited", "Enterprise-scale") in the primary text color and the rest of
    // the label in the secondary color — per Figma. Support / per-user rows have
    // no leading quantity and stay fully primary.
    const renderCrmQuantityLabel = (text)=>{
        const spaceIndex = text.indexOf(" ");
        if (spaceIndex === -1) {
            return /*#__PURE__*/ _jsx("span", {
                className: "feature-quantity",
                children: text
            });
        }
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("span", {
                    className: "feature-quantity",
                    children: text.slice(0, spaceIndex)
                }),
                /*#__PURE__*/ _jsx("span", {
                    className: "feature-secondary",
                    children: text.slice(spaceIndex)
                })
            ]
        });
    };
    const renderClassicFeatureRow = (feature, { isAIFeature = false, splitQuantity = false } = {})=>{
        // Prefer a tier-scoped description; for CRM classic rows fall back to the
        // shared per-feature namespace used by the pre-classic layout (via
        // CRM_CLASSIC_DESCRIPTION_ALIASES for renamed ids). This restores the
        // tooltips the CRM card had before, reusing the existing copy.
        const descriptionId = FEATURE_DESCRIPTION_ID_OVERRIDES[feature] || feature;
        const tierDescriptionKey = `pricingPage.products.${productName}.tiers.${tierName}.features.${descriptionId}.description`;
        let descriptionKey = tierDescriptionKey;
        if (translate(tierDescriptionKey) === tierDescriptionKey && isCrmClassic && !CRM_CLASSIC_DESCRIPTION_DENYLIST.has(feature)) {
            const sharedFeature = CRM_CLASSIC_DESCRIPTION_ALIASES[feature] || feature;
            descriptionKey = `pricingPage.products.${productName}.features.${sharedFeature}.description`;
        }
        const hasDescription = translate(descriptionKey) !== descriptionKey;
        const featureLabel = translate(`pricingPage.products.${productName}.tiers.${tierName}.features.${feature}`);
        const tooltipNode = hasDescription && /*#__PURE__*/ _jsx("div", {
            className: "tooltip",
            children: /*#__PURE__*/ _jsx(TooltipComponent, {
                theme: DARK_THEME,
                className: "floating-tooltip",
                children: translate(descriptionKey)
            })
        });
        return /*#__PURE__*/ _jsxs("div", {
            className: classnames("feature", {
                "tooltip-on-text": isCrmClassic
            }),
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "name-and-label",
                    onMouseEnter: hasDescription ? ()=>onMouseEnter(feature) : undefined,
                    onMouseLeave: hasDescription ? ()=>onMouseLeave(feature) : undefined,
                    children: [
                        isCrmClassic && tooltipNode,
                        isAIFeature && /*#__PURE__*/ _jsx(MondayAiIcon, {}),
                        !isAIFeature && FEATURE_LEADING_ICONS[feature],
                        isCrmClassic && splitQuantity ? renderCrmQuantityLabel(featureLabel) : /*#__PURE__*/ _jsx(MondayMarkupLanguageComponent, {
                            tagName: "span",
                            text: featureLabel
                        }),
                        !isAIFeature && labeledTierFeatures[feature] && /*#__PURE__*/ _jsx(Label, {
                            text: translate(labeledTierFeatures[feature]),
                            borderColor: "blue"
                        })
                    ]
                }),
                !isCrmClassic && /*#__PURE__*/ _jsxs("div", {
                    className: "icon",
                    onMouseEnter: ()=>onMouseEnter(feature),
                    onMouseLeave: ()=>onMouseLeave(feature),
                    children: [
                        tooltipNode,
                        /*#__PURE__*/ _jsx(PricingInfoIcon, {
                            className: "info-icon"
                        })
                    ]
                })
            ]
        });
    };
    // CRM classic Ultimate card matches Figma's grouped spacing exactly (uniform
    // margins can't express it): the "Our absolute best support" heading + its
    // icon rows (onboarding / support) sit 16px apart, a 32px break to the
    // quantity rows (12px apart), a 32px break to the "Includes Pro, plus:"
    // section (16px heading gap, 8px rows). Flex `gap` on nested containers drives
    // every gap; the shared per-row margin is zeroed via `.crm-ultimate-sections`.
    const renderCrmUltimateFeatures = ()=>{
        const topFeatures = filterOutAiFeaturesIfCreditsEnabled(featuresOrMaxDiffFeatures, enableCreditsPricing, productName);
        const hasLeadingIcon = (feature)=>Boolean(FEATURE_LEADING_ICONS[feature]) && !AI_FEATURES.includes(feature);
        const iconFeatures = topFeatures.filter(hasLeadingIcon);
        const valueFeatures = topFeatures.filter((feature)=>!hasLeadingIcon(feature));
        return /*#__PURE__*/ _jsxs("div", {
            className: "crm-ultimate-sections",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "crm-section",
                    children: [
                        tier.topSectionIncludesFrom && /*#__PURE__*/ _jsx("div", {
                            className: "enterprise-section-heading",
                            children: translate("pricingPage.tierCards.ourAbsoluteBestSupport")
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "crm-rows crm-rows--icons",
                            children: iconFeatures.map((feature)=>/*#__PURE__*/ _jsx(Fragment, {
                                    children: renderClassicFeatureRow(feature, {
                                        isAIFeature: false
                                    })
                                }, feature))
                        })
                    ]
                }),
                valueFeatures.length > 0 && /*#__PURE__*/ _jsx("div", {
                    className: "crm-rows crm-rows--values",
                    children: valueFeatures.map((feature)=>/*#__PURE__*/ _jsx(Fragment, {
                            children: renderClassicFeatureRow(feature, {
                                isAIFeature: AI_FEATURES.includes(feature),
                                splitQuantity: !AI_FEATURES.includes(feature) && !FEATURE_LEADING_ICONS[feature]
                            })
                        }, feature))
                }),
                tier.perUserFeatures && tier.perUserFeatures.length > 0 && /*#__PURE__*/ _jsxs("div", {
                    className: "crm-section",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "enterprise-section-heading",
                            children: tierIncludesText
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "crm-rows crm-rows--peruser",
                            children: tier.perUserFeatures.map((feature)=>/*#__PURE__*/ _jsx(Fragment, {
                                    children: renderClassicFeatureRow(feature)
                                }, feature))
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ _jsxs(ConditionalWrapper, {
        condition: isHomepagePricing,
        wrapper: (children)=>/*#__PURE__*/ _jsxs(StyledProductPriceAndFeaturesWrapper, {
                styleColor: isHomepagePricing ? "auto" : color,
                ctaHoverBackgroundColor: ctaHoverBackgroundColor,
                ctaHoverBorderColor: ctaHoverBorderColor,
                ctaHoverTextColor: ctaHoverTextColor,
                isContactUsCard: !shouldShowPrices,
                isMobileOrTabletBrowser: isMobileOrTabletBrowser,
                isNewPricing: isNewPricingChrome,
                isCrmClassic: isCrmClassic,
                className: classnames("card-container", {
                    "is-homepage-pricing": isHomepagePricing,
                    "is-most-popular": isMostPopular
                }),
                children: [
                    isHomepagePricing && isMostPopular && /*#__PURE__*/ _jsx("div", {
                        className: "most-popular",
                        children: /*#__PURE__*/ _jsx("span", {
                            className: "most-popular-span",
                            children: translate("pricingPage.mostPopular")
                        })
                    }),
                    children
                ]
            }),
        children: [
            /*#__PURE__*/ _jsxs(StyledProductPriceAndFeatures, {
                ref: mobileCardWrapperRef,
                styleColor: isHomepagePricing ? "auto" : color,
                ctaHoverBackgroundColor: ctaHoverBackgroundColor,
                ctaHoverBorderColor: ctaHoverBorderColor,
                ctaHoverTextColor: ctaHoverTextColor,
                isContactUsCard: !shouldShowPrices,
                isMobileOrTabletBrowser: isMobileOrTabletBrowser,
                className: classnames(CARD_CLASS, {
                    "is-most-popular": isMostPopular
                }),
                isNewPricing: isNewPricingChrome,
                isCrmClassic: isCrmClassic,
                style: _object_spread({
                    "--primary-color": primaryColor,
                    "--secondary-color": secondaryColor,
                    // The card's CTAs only (see .cta-button in the styles): black instead of a purple product color on
                    // the new brand. Other uses of the product colors, and non-purple products, keep their color.
                    "--cta-primary-color": getBrandCtaHexColor(primaryColor, isNewBrand),
                    "--cta-secondary-color": getBrandCtaHexColor(secondaryColor, isNewBrand)
                }, minMobileCardHeight ? {
                    minHeight: `${minMobileCardHeight + 44}px`
                } : {}),
                children: [
                    !isHomepagePricing && /*#__PURE__*/ _jsx("div", {
                        className: "icons",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "icon",
                            style: {
                                "--product-color": productColor
                            },
                            children: /*#__PURE__*/ _jsx(ProductIcon, {
                                product: productName
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "tier-title-container",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: `tier-title ${isNewPricingChrome ? "new-pricing" : ""}`,
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "product-and-tier",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "tier",
                                            children: translatedTierName
                                        }),
                                        isHomepagePricing && showComingSoon && /*#__PURE__*/ _jsx("div", {
                                            onMouseEnter: onMouseEnterComingSoon,
                                            className: "coming-soon",
                                            children: translate("pricingPage.comingSoon")
                                        }),
                                        !isHomepagePricing && productName !== PLATFORM_PRODUCT_IDS[WORK_MANAGEMENT_PRODUCT_ID] && productName !== PLATFORM_PRODUCT_IDS[MARKETING_CAMPAIGNS_PRODUCT_ID] && /*#__PURE__*/ _jsx("div", {
                                            children: translate(`pricingPage.products.${productName}.title`)
                                        })
                                    ]
                                }),
                                !isHomepagePricing && isMostPopular && /*#__PURE__*/ _jsx("div", {
                                    className: "most-popular-badge-container",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "most-popular-badge",
                                        children: translate("pricingPage.mostPopular")
                                    })
                                })
                            ]
                        })
                    }),
                    (isNewPricingChrome && crossedPricingUI || useClassicCardChrome) && /*#__PURE__*/ _jsx("div", {
                        className: "description --no-space",
                        children: translate(`pricingPage.products.${productName}.tiers.${tier.name}.description${isNewPricingChrome ? ".newPricing" : ""}`)
                    }),
                    enableCreditsPricing && productName === PLATFORM_PRODUCT_IDS[WORK_MANAGEMENT_PRODUCT_ID] ? /*#__PURE__*/ _jsxs("div", {
                        className: "credits-section-wrapper",
                        ref: creditsWrapperRef,
                        style: minCreditsWrapperHeight ? {
                            minHeight: `${minCreditsWrapperHeight}px`
                        } : undefined,
                        children: [
                            shouldShowPrices ? /*#__PURE__*/ _jsx(ProductPrice, {
                                product: productName,
                                period: period,
                                seats: seats,
                                tierName: tierName,
                                hideFreeForever: hideFreeForever,
                                splitCurrencySign: isHomepagePricing,
                                isNewPricing: isNewPricing,
                                unitOfMeasure: unitOfMeasure,
                                crossedPricingUI: crossedPricingUI,
                                crmClassic: isCrmClassic,
                                hideDiscounts: creditsPerSeat,
                                showCrossedOutPrice: creditsPerSeat,
                                addon: effectiveAddon,
                                addonTotalPrice: addonTotalPrice,
                                selectedCredits: selectedCredits
                            }) : /*#__PURE__*/ _jsx("div", {
                                className: classnames("contact", {
                                    "enterprise-contact": tierName === TIERS.ENTERPRISE
                                }),
                                children: tierName === TIERS.ENTERPRISE ? /*#__PURE__*/ _jsxs(_Fragment, {
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "enterprise-icon-and-price",
                                            children: [
                                                isHomepagePricing ? isNewPricingChrome ? /*#__PURE__*/ _jsx(NewEnterpriseIcon, {}) : /*#__PURE__*/ _jsx(EnterpriseIcon, {}) : /*#__PURE__*/ _jsx(ContactUsIcon, {}),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "enterprise-custom-price",
                                                    children: translate("pricingPage.enterprise.customPrice")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "enterprise-description-text",
                                            children: translate("pricingPage.enterprise.description.fullyCustomized")
                                        })
                                    ]
                                }) : isHomepagePricing ? isNewPricingChrome ? /*#__PURE__*/ _jsx(NewEnterpriseIcon, {}) : /*#__PURE__*/ _jsx(EnterpriseIcon, {}) : /*#__PURE__*/ _jsx(ContactUsIcon, {})
                            }),
                            tierName === TIERS.ENTERPRISE ? !creditsPerSeat && period !== "monthly" && /*#__PURE__*/ _jsx("div", {
                                className: "enterprise-discounts-available",
                                children: translate("pricingPage.credits.discountsAvailable")
                            }) : !creditsPerSeat && /*#__PURE__*/ _jsx(CreditsSpecialOffer, {
                                tierName: tierName,
                                period: period,
                                currency: currency,
                                seats: seats
                            })
                        ]
                    }) : /*#__PURE__*/ _jsx(_Fragment, {
                        children: shouldShowPrices ? /*#__PURE__*/ _jsx(ProductPrice, {
                            product: productName,
                            period: period,
                            seats: seats,
                            tierName: tierName,
                            hideFreeForever: hideFreeForever,
                            splitCurrencySign: isHomepagePricing,
                            isNewPricing: isNewPricing,
                            unitOfMeasure: unitOfMeasure,
                            crossedPricingUI: crossedPricingUI,
                            crmClassic: isCrmClassic,
                            hideDiscounts: creditsPerSeat,
                            showCrossedOutPrice: creditsPerSeat,
                            addon: effectiveAddon,
                            addonTotalPrice: addonTotalPrice
                        }) : /*#__PURE__*/ _jsx("div", {
                            className: "contact",
                            children: isCrmClassic ? /*#__PURE__*/ _jsxs("div", {
                                className: "crm-ultimate-price",
                                children: [
                                    /*#__PURE__*/ _jsx(EnterpriseIcon, {}),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "crm-ultimate-price-text",
                                        children: translate("pricingPage.products.crm.tiers.enterprise.customPrice")
                                    })
                                ]
                            }) : isHomepagePricing ? isNewPricingChrome ? /*#__PURE__*/ _jsx(NewEnterpriseIcon, {}) : /*#__PURE__*/ _jsx(EnterpriseIcon, {}) : /*#__PURE__*/ _jsx(ContactUsIcon, {})
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: classnames("cta-button", {
                            "try-cta-padding": canPurchaseNow && isFreeOrEnterprise,
                            "contact-us": !shouldShowPrices
                        }),
                        children: shouldShowPrices ? /*#__PURE__*/ _jsx("div", {
                            className: "signup-form-wrapper",
                            children: /*#__PURE__*/ _jsx(SignupFormComponent, {
                                className: "signup-form",
                                ctaText: translate("signup.tryForFree"),
                                buttonSize: "xs",
                                forceInputHide: true,
                                useCtaText: true,
                                buttonSpinnerColor: Colors[BRAND_BLACK_TEXT_COLOR],
                                pricingDetails: {
                                    tier: tierName,
                                    userCount: seats,
                                    billingPeriod: period,
                                    product: productName
                                },
                                signupProductId: productId,
                                extraData: {
                                    pricing_tier: tierName,
                                    cta_name: "tier_cards"
                                },
                                beforeSubmitCallback: handleBeforeSubmitCallback,
                                buttonClassName: (isNewPricingChrome || isCrmClassic) && !isMostPopular ? classnames("cta-button", "contact-us-button") : ""
                            })
                        }) : /*#__PURE__*/ _jsx(Button, {
                            className: classnames("cta-button", "contact-us-button"),
                            type: "button",
                            size: "xs",
                            onClickCallback: onContactUsClick,
                            children: contactUsText
                        })
                    }),
                    canPurchaseNow && !isFreeOrEnterprise && /*#__PURE__*/ _jsxs("div", {
                        className: "pricing-signup-purchase-now",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                children: (_translate = translate("signup.or")) === null || _translate === void 0 ? void 0 : _translate.toLowerCase()
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                className: "purchase-now-link",
                                onClick: onPurchaseNowClick,
                                children: translate("pricingPage.purchaseNow")
                            })
                        ]
                    }),
                    isHomepagePricing && !isNewPricingChrome && !(enableCreditsPricing && productName === PLATFORM_PRODUCT_IDS[WORK_MANAGEMENT_PRODUCT_ID]) && renderLearnMoreVideoCTAOrPlaceholder(),
                    !isNewPricingChrome && !useClassicCardChrome && !(enableCreditsPricing && productName === PLATFORM_PRODUCT_IDS[WORK_MANAGEMENT_PRODUCT_ID]) ? /*#__PURE__*/ _jsx("div", {
                        className: "description",
                        children: translate(`pricingPage.products.${productName}.tiers.${tier.name}.description${isNewPricingChrome ? ".newPricing" : ""}`)
                    }) : null,
                    !isNewPricingChrome && /*#__PURE__*/ _jsx("div", {
                        className: "horizontal-line"
                    }),
                    (enableCreditsPricing && productName === PLATFORM_PRODUCT_IDS[WORK_MANAGEMENT_PRODUCT_ID] || useClassicCardChrome && productName === CRM_PRODUCT_ID && tierName !== TIERS.BASIC) && /*#__PURE__*/ _jsx("div", {
                        className: classnames("tier-ai-block-wrapper", {
                            simplified: useClassicCardChrome && productName === CRM_PRODUCT_ID
                        }),
                        children: /*#__PURE__*/ _jsx(TierAiBlock, {
                            tierName: tierName,
                            simplified: useClassicCardChrome && productName === CRM_PRODUCT_ID,
                            titleOverride: isCrmClassic ? `${translatedTierName} AI` : undefined,
                            creditsPerSeat: creditsPerSeat && productName === PLATFORM_PRODUCT_IDS[WORK_MANAGEMENT_PRODUCT_ID],
                            seats: seats
                        })
                    }),
                    !(enableCreditsPricing && productName === PLATFORM_PRODUCT_IDS[WORK_MANAGEMENT_PRODUCT_ID]) && tierName === TIERS.ENTERPRISE && productName === PLATFORM_PRODUCT_IDS[WORK_MANAGEMENT_PRODUCT_ID] && /*#__PURE__*/ _jsx("div", {
                        className: "expandable-bundle",
                        children: /*#__PURE__*/ _jsx(AiExpandableBundle, {
                            title: translate("pricingPage.enterprise.aiBundle.title"),
                            heading: translate("pricingPage.enterprise.aiBundle.heading"),
                            subtitle: translate("pricingPage.enterprise.aiBundle.subtitle"),
                            description: translate("pricingPage.enterprise.aiBundle.description"),
                            productLogos: oneAiProductLogos
                        })
                    }),
                    isHomepagePricing && !isNewPricingChrome && !isCrmClassic && /*#__PURE__*/ _jsx("div", {
                        className: "tier-include",
                        children: tierIncludesText
                    }),
                    isNewPricingChrome ? /*#__PURE__*/ _jsx(NewCardFeatures, {
                        features: tier.newFeatures,
                        isMostPopular: isMostPopular,
                        tier: tier,
                        productName: productName,
                        addon: effectiveAddon
                    }) : /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(PricingFeature, {
                                addon: effectiveAddon,
                                selectedUnit: selectedUnit
                            }),
                            isCrmClassic && tierName === TIERS.ENTERPRISE ? renderCrmUltimateFeatures() : /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    isCrmClassic && tierName === TIERS.BASIC && /*#__PURE__*/ _jsx("div", {
                                        className: "enterprise-section-heading",
                                        children: translate(AI_USAGE_HEADING_KEY)
                                    }),
                                    filterOutAiFeaturesIfCreditsEnabled(featuresOrMaxDiffFeatures, enableCreditsPricing, productName).map((feature, index)=>{
                                        const isAIFeature = AI_FEATURES.includes(feature);
                                        // WM anchors its "Top tier support" heading mid-list at
                                        // creditsEnterpriseSupport. CRM classic shows an "Includes
                                        // <tier>, plus:" heading above the whole list (only for tiers
                                        // with topSectionIncludesFrom, i.e. Ultimate) — anchoring it at
                                        // the first feature so the leading row (tailored onboarding)
                                        // isn't orphaned above the heading.
                                        const showTopSectionHeading = isCrmClassic ? Boolean(tier.topSectionIncludesFrom) && index === 0 : feature === TOP_TIER_SUPPORT_SECTION_START || feature === CREDITS_PER_SEAT_TOP_TIER_SUPPORT_SECTION_START;
                                        return /*#__PURE__*/ _jsxs(Fragment, {
                                            children: [
                                                showTopSectionHeading && /*#__PURE__*/ _jsx("div", {
                                                    className: "enterprise-section-heading",
                                                    children: isCrmClassic ? tier.topSectionIncludesFrom ? translateWithParam("pricingPage.tierCards.includesPlanPlus", translate(getCapitilizedString(tier.topSectionIncludesFrom))) : tierIncludesText : translate("pricingPage.enterprise.topTierSupport.heading")
                                                }),
                                                renderClassicFeatureRow(feature, {
                                                    isAIFeature,
                                                    splitQuantity: isCrmClassic && !isAIFeature && !FEATURE_LEADING_ICONS[feature]
                                                })
                                            ]
                                        }, feature);
                                    }),
                                    tier.perUserFeatures && tier.perUserFeatures.length > 0 && /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "enterprise-section-heading",
                                                children: isCrmClassic ? tierIncludesText : translate(PER_USER_PER_MONTH_HEADING_KEY)
                                            }),
                                            isCrmClassic ? // CRM classic bottom section ("Includes <tier>, plus:") uses a
                                            // tighter 8px row gap per Figma — wrap so the spacing is scoped
                                            // to these rows and doesn't touch the top feature list.
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "crm-per-user-features",
                                                children: tier.perUserFeatures.map((feature)=>/*#__PURE__*/ _jsx(Fragment, {
                                                        children: renderClassicFeatureRow(feature)
                                                    }, feature))
                                            }) : tier.perUserFeatures.map((feature)=>/*#__PURE__*/ _jsx(Fragment, {
                                                    children: renderClassicFeatureRow(feature)
                                                }, feature))
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    isNewPricingChrome && tierName === TIERS.ENTERPRISE && /*#__PURE__*/ _jsxs("div", {
                        className: "security-logos",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "white-glove-migration",
                                children: translate("pricingPage.products.crm.tiers.enterprise.securityAndControl")
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "logos-container",
                                children: [
                                    /*#__PURE__*/ _jsx(PictureComponent, {
                                        src: HIPAA_LOGO_SRC,
                                        alt: "hipaa",
                                        className: "logo"
                                    }),
                                    /*#__PURE__*/ _jsx(PictureComponent, {
                                        src: SOC_LOGO_SRC,
                                        alt: "soc",
                                        className: "logo"
                                    })
                                ]
                            })
                        ]
                    }),
                    isCrmClassic && tierName === TIERS.ENTERPRISE && /*#__PURE__*/ _jsxs("div", {
                        className: "crm-white-glove-migration",
                        children: [
                            /*#__PURE__*/ _jsx(PictureComponent, {
                                src: HIPAA_LOGO_SRC,
                                alt: "hipaa",
                                className: "logo"
                            }),
                            /*#__PURE__*/ _jsx(PictureComponent, {
                                src: SOC_LOGO_SRC,
                                alt: "soc",
                                className: "logo"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "wgm-divider"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "wgm-text",
                                children: translate("pricingPage.products.crm.tiers.enterprise.whiteGloveMigration")
                            })
                        ]
                    })
                ]
            }),
            shouldShowDisclaimerForEnterprise() && /*#__PURE__*/ _jsx("div", {
                className: "enterprise-disclaimer",
                children: translate("pricingPage.plans.enterprise.disclaimer")
            })
        ]
    });
};
export default withAbTests(ProductPriceAndFeatures);
